import { orderBy } from "lodash";
import { memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import useStyles from "./styles";
import { setFilters, setSearchVal } from "./slaTableFiltersSlice";
import DataTable from "components/DataTable/DataTable";
import useSortOptions from "hooks/useSortOptions";
import FilterService, { fieldTypes } from "services/filterService";
import FormatService from "services/formatService";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { useGetLotsQuery } from "features/lots/lotSlice";
import { arrayToObject } from "utils/object-util";

const SlaTable = ({
    washSlaData,
}) => {

    const classes = useStyles();
    const [sortOptions, sortData] = useSortOptions();
    const dispatch = useDispatch();
    let { data: lots, error: lotsError, isLoading: isLoadingLots } = useGetLotsQuery();
    const { searchVal, filters } = useSelector(state => state.slaTableFilters);
    const lotsLookup = arrayToObject(lots);
    let assetsSlaList = washSlaData?.filter(a => a.underSlaInLastCycle != null).map(a => ({
        ...a,
        formattedDate: FormatService.formatDate(a.latestCompletedWash),
        withInSlaStr: a.underSlaInLastCycle ? 'Within SLA' : 'Above SLA',
        daysOnLotInCycleFormatted: Math.round(a.daysOnLotInCycle),
        lotName: lotsLookup[a.lotId]?.name,
    })) || [];


    const columns = [
        { name: "VIN", key: "descriptor", component: (row) => <Link target='_blank' to={`/assets/detail/${row?.vehicleId}`} className={classes.link}>{row?.descriptor}</Link> },
        { name: "Asset Id", key: "assetId" },
        { name: "Lot", key: "lotName" },
        { name: "Within SLA", key: "underSlaInLastCycle", component: (row) => withinSlaColumn(row.underSlaInLastCycle) },
        { name: "Latest Completed Wash", key: "formattedDate" },
        { name: "Dwell Days in Cycle", key: "daysOnLotInCycleFormatted" }
    ];

    const withinSlaColumn = (underSlaInLastCycle) => {
        return <div className={`${classes.withinSlaColumn} ${underSlaInLastCycle ? classes.withinSla : classes.aboveSla}`}>
            {underSlaInLastCycle ? 'Within SLA' : 'Above SLA'
            }
        </div>
    }

    const filterConfig = [
        {
            type: fieldTypes.LIST,
            size: 2,
            title: 'Within SLA',
            key: 'underSlaInLastCycle',
            multiple: true,
            values: [{ name: 'Within SLA', id: true }, { name: 'Above SLA', id: false }],
        },
        {
            type: fieldTypes.LOT,
            size: 2,
            title: 'Lot',
            key: 'lotId',
            multiple: true,
            values: lots,
        }
    ];

    const onDropFilter = (filterValue, prop) => {
        updateFilters(prop, filterValue);
    };

    const updateFilters = (prop, value) => {
        const newFilters = { ...filters, [prop]: { value } }
        dispatch(setFilters(newFilters));
    }
    const searchByText = value => {
        dispatch(setSearchVal(value.trim()));
    }

    const onResetFilters = () => {
        dispatch(setFilters({
            clientId: { value: null },
            lotId: { value: null }
        }));
    }

    let filteredData = FilterService.filter(filters, searchVal, assetsSlaList, filterConfig);

    const mapExportData = (a => {
        return {
            ['VIN']: a.descriptor,
            ['Asset Id']: a.assetId,
            ['Within SLA']: a.withInSlaStr,
            ['Latest Completed Wash']: a.formattedDate,
            ['Dwell Days in Cycle']: a.daysOnLotInCycleFormatted,
            ['Lot']: a.lotName,
        }
    })

    return (
        <>
            <DataTable
                title={`Asset Wash Status for Current Cycle (${filteredData?.length})`}
                columns={columns}
                rows={orderBy(
                    filteredData,
                    sortOptions.columnToSort,
                    sortOptions.sortDirection
                )}
                rowIdentifier='id'
                onSort={sortData}
                noItemsMessage={'No Data'}
                sortDirection={sortOptions.sortDirection}
                columnToSort={sortOptions.columnToSort}
                mapExportData={mapExportData}
                onSearch={searchByText}
                searchVal={searchVal}

                dropDownsConfig={filterConfig}
                filters={filters}
                onDropFilter={onDropFilter}
                withFilterPanel={true}
                onResetFilters={onResetFilters}
            />
        </>
    );
};

export default memo(SlaTable);
